import userDetail from './user-detail.vue'

export default userDetail
